import React from 'react';
import { roles } from '@nxsys/store/constants';
import { PayrollCountryType } from '@nxsys/types/models/Common';

const FPSListing = React.lazy(() => import('../../../modules/rti/listing/FPS'));
const FPSDetails = React.lazy(() => import('../../../modules/rti/details/FPS'));
const EPSListing = React.lazy(() => import('../../../modules/rti/listing/EPS'));
const CIS300Listing = React.lazy(
  () => import('../../../modules/rti/listing/CIS300'),
);
const EPSDetails = React.lazy(() => import('../../../modules/rti/details/EPS'));
const CIS300Details = React.lazy(
  () => import('../../../modules/rti/details/CIS300'),
);
const SafeRecSubmissionDetails = React.lazy(
  () => import('../../../modules/rti/details/SafeRecSubmission'),
);

export const rtiFilingsHistoryConfigUmbrella = [
  {
    permittedRole: [roles.admin],
    path: '/rti-filings/fps',
    element: <FPSListing />,
  },
  {
    permittedRole: [roles.admin],
    path: '/rti-filings/fps/:id',
    element: <FPSDetails />,
  },
  {
    permittedRole: [roles.admin],
    path: '/rti-filings/eps',
    element: <EPSListing />,
  },
  {
    permittedRole: [roles.admin],
    path: '/rti-filings/eps/:id',
    element: <EPSDetails />,
  },
  {
    permittedRole: [roles.admin],
    path: '/rti-filings/cis-300',
    element: <CIS300Listing />,
  },
  {
    permittedRole: [roles.admin],
    path: '/rti-filings/cis-300/:id',
    element: <CIS300Details />,
  },
  {
    permittedRole: [roles.admin],
    path: '/rti-filings/safe-rec-submission/:type/:id',
    element: <SafeRecSubmissionDetails />,
  },
];

export const rtiFilingsHistoryConfigBureau = [
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/rti-filings/fps',
    element: <FPSListing />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/rti-filings/fps/:id',
    element: <FPSDetails />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/rti-filings/eps',
    element: <EPSListing />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/rti-filings/eps/:id',
    element: <EPSDetails />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/rti-filings/safe-rec-submission/:type/:id',
    element: <SafeRecSubmissionDetails />,
  },
];

export const rtiFilingsHistoryConfig = (
  isBureau: boolean,
  payrollCountry: PayrollCountryType,
) => {
  // Closed for every Ireland tenant, bureau or umbrella: the `rti-filings-history`
  // sidebar id is already dropped/replaced in both Ireland route sets (routeConfig.tsx),
  // this is the second guard that keeps the deep link closed if the id ever returns.
  if (payrollCountry === 'IRELAND') return [];
  if (isBureau) {
    return rtiFilingsHistoryConfigBureau;
  }
  return rtiFilingsHistoryConfigUmbrella;
};
